import { Link } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';

export default function NotFoundPage(): JSX.Element {
  return (
    <PageLayout title="Page Not Found" showStatusBar={false}>
      <div style={{ textAlign: 'center', padding: '80px 20px' }}>
        <p style={{ fontSize: 64, margin: '0 0 16px', lineHeight: 1 }} aria-hidden="true">
          404
        </p>
        <p style={{ fontSize: 15, color: 'var(--text-navy-secondary)', margin: '0 0 24px' }}>
          The page you requested does not exist.
        </p>
        <Link
          to="/dashboard"
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: 'var(--brand-primary)',
            textDecoration: 'none',
            padding: '8px 20px',
            border: '1px solid var(--brand-primary)',
            borderRadius: 'var(--radius-lg)',
          }}
        >
          Back to Dashboard
        </Link>
      </div>
    </PageLayout>
  );
}
